export default "__VITE_ASSET__dGKFSdQB__"